export const checkLocaleCode = (lang: string) => {
  switch (true) {
    case lang === 'ko':
      return 'kr';
    default:
      return lang;
  }
};
